export const blockIconsPrivacyandsecurityExclamationNew = (
	<span className='material-symbols-outlined'>exclamation</span>
);
